var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"alert-wrapper",attrs:{"tag":"div","name":"flash-wrapper"}},_vm._l((_vm.flashes),function(flash){return _c('flash',{key:flash.uid,attrs:{"flash":flash},on:{"onRemoveFlash":function($event){return _vm.removeFlash($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }